export default {
  token: {
    colorPrimary: "#0f5ef7",
    colorInfoText: "#0f5ef7",
    colorInfoHover: "#3673ec",
  },
};
